import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { WarningLarge } from '@yme/assets/icons';
import { ModalWindowFooter } from '@yme/atoms/modal-footer';
import { MD_MODAL, StaticModalWindow } from '@yme/atoms/modal-window';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { resetPaymentErrors } from '@yme/components/CheckoutForm/PaymentForm/PaymentOptions/TerminalOnline/redux/actions';
import { getTerminalPaymentState } from '@yme/components/CheckoutForm/PaymentForm/PaymentOptions/TerminalOnline/redux/selectors';
import { useModal } from '@yme/modals/hooks';
import { getModalData } from '@yme/modals/selectors';
import { getRTL, getAnotherSessionLabels } from '@yme/selectors/common';
import { colorCoreBlack300 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { kioskLogout } from '@yme/utils/kiosk';
import { IconWrapper } from './';
const CustomModalFooter = ({ altSubmitLabel, cb }) => {
    const { clearButton, continueButton } = useSelector(getAnotherSessionLabels);
    const { isWentWrong } = useSelector(getTerminalPaymentState);
    const { handleProceedToCheckout, cleanSession } = useModal();
    const dispatch = useDispatch();
    const handleClearCart = async () => {
        await cleanSession();
        dispatch(resetPaymentErrors());
        kioskLogout();
    };
    const cancelButtonLabel = isWentWrong ? clearButton : continueButton;
    const submitButtonLabel = isWentWrong ? altSubmitLabel : clearButton;
    const handleSubmit = isWentWrong ? cb : handleClearCart;
    const handleCancel = isWentWrong ? handleClearCart : handleProceedToCheckout;
    return (React.createElement(ModalWindowFooter, { isWrapReverse: true, isSubmitButton: true, isCancelButtonFullWidth: true, isCancelButton: isWentWrong, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, onCancel: handleCancel, onSubmit: handleSubmit }));
};
export function TerminalWrongOrderModal() {
    const isRightToLeft = useSelector(getRTL);
    const { description, title = '', altSubmitLabel, cb, } = useSelector(getModalData) || {};
    return (React.createElement(StaticModalWindow, { hasCloseButton: false, title: title, staticModalSize: MD_MODAL, minHeight: "auto", isRightToLeft: isRightToLeft, footerComponent: React.createElement(CustomModalFooter, { cb: cb, altSubmitLabel: altSubmitLabel }), isClickOutsideDisabled: true },
        React.createElement(FlexWrapper, { justifyContent: "center", isFullWidth: true, mb: INDENT.sm },
            React.createElement(IconWrapper, null,
                React.createElement(SVGIcon, { type: WarningLarge, size: ICON_SIZE.l }))),
        description && (React.createElement(RegularTextLevel3, { color: colorCoreBlack300 }, description))));
}
